import { render } from "./traffic.vue?vue&type=template&id=5c744076&scoped=true"
import script from "./traffic.vue?vue&type=script&lang=js"
export * from "./traffic.vue?vue&type=script&lang=js"

import "./traffic.vue?vue&type=style&index=0&id=5c744076&lang=scss&scoped=true"

import exportComponent from "E:\\Gitlab\\02_各园区PC端\\happyHarbour\\ningbo\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c744076"]])

export default __exports__